import { name } from "./";

const selectRegReference = (state) => state[name].regReference;
const selectUserDetails = (state) => state[name].userDetails;

export { selectRegReference, selectUserDetails };
